import React from "react";
import DotLoader from "react-spinners/DotLoader";

export default function Loading({ className, size, light, dark }) {
  return (
    <div className={className}>
      <DotLoader
        color={light ? "#fff" : dark ? "#CA1320" : "#246BFD"}
        loading="true"
        size={size}
      />
    </div>
  );
}
